function validateContract(contractId, noContract, reason, submitting, allowNone = true) {
  if (noContract && !allowNone) throw Error('开票申请请选择实际合同')
  if (contractId && noContract) throw Error('合同与无合同不能同时选择')
  if (submitting && !contractId && !noContract) throw Error('请选择关联合同；无合同时请选择“无”并填写说明')
  if (noContract && submitting && !String(reason || '').trim()) throw Error('请填写无合同说明')
  if (noContract && String(reason || '').trim().length > 500) throw Error('无合同说明最多500字')
}
module.exports = { validateContract }
